import gql from 'graphql-tag';

export const coopGoogleCalendarManually = gql`
  mutation coopGoogleCalendar($input: GoogleCalendarCoopInput!) {
    coopGoogleCalendar(input: $input) {
      empty
    }
  }
`;
